"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoatingOk = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const BoatingOk = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "boating-ok", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "boating-ok", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M24 15.505v-4.332c0-.512-.38-.943-.884-1.002l-9.888-1.164a.997.997 0 0 0-.984.501l-2.847 5.026L1 13.976c.673 5.373 4.04 8.06 10.101 8.06l17.378.962a1.01 1.01 0 0 0 1.027-.729l1.455-5.08a1.008 1.008 0 0 0-.904-1.282L24 15.506Zm-12.388-.824L22 15.372v-3.319l-8.343-.982-2.045 3.61Z", fill: "#DF7B01", fillRule: "evenodd" }) })) })));
};
exports.BoatingOk = BoatingOk;
